import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Typography } from '@mui/material';
import { createSearchParams, useNavigate } from 'react-router-dom';

export default function ThreeDotMenu({ isActive, fetchData, accountType, id, accountNumber, isMainTable }: { isActive: any, fetchData: any, accountType: any, accountNumber: any, id: number, isMainTable: string }) {
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const params: any = [
        ['customerId', id],
        ['isMainTable', isMainTable],
    ];

    return (
        <>
            <div>
                <IconButton
                    aria-label="more"
                    id="long-button"
                    aria-controls={open ? 'long-menu' : undefined}
                    aria-expanded={open ? 'true' : undefined}
                    aria-haspopup="true"
                    onClick={handleClick}
                    style={{ width: '30px', height: '30px' }}
                >
                    <MoreVertIcon />
                </IconButton>
                <Menu
                    id="long-menu"
                    MenuListProps={{
                        'aria-labelledby': 'long-button',
                    }}
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                >
                    {accountType === 0 || accountType === 1 ? (
                        [
                            <MenuItem
                                key="add-attorney"
                                onClick={() => {
                                    navigate({
                                        pathname: `new-registration`,
                                        search: `?attorney&${createSearchParams(params)}`,
                                    });
                                    handleClose();
                                }}
                            >
                                <Typography>Add Attorney</Typography>
                            </MenuItem>,
                            accountType !== 1 && (
                                <MenuItem
                                    key="add-joint-account"
                                    onClick={() => {
                                        navigate({
                                            pathname: `new-registration`,
                                            search: `?joint&${createSearchParams(params)}`,
                                        });
                                        handleClose();
                                    }}
                                >
                                    <Typography>Add Joint Account</Typography>
                                </MenuItem>
                            ),
                        ]
                    ) : null}
                </Menu>
            </div>
        </>
    );
}